var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDataC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "#E9F2FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3683_4159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.79297 5.68783C3.79297 5.17703 3.79297 4.92191 3.95168 4.7632C4.11039 4.60449 4.36551 4.60449 4.8763 4.60449H8.1263C8.63709 4.60449 8.89222 4.60449 9.05093 4.7632C9.20964 4.92191 9.20964 5.17703 9.20964 5.68783C9.20964 5.81539 9.20964 5.8793 9.17009 5.91912C9.13028 5.95866 9.06609 5.95866 8.9388 5.95866H4.0638C3.93624 5.95866 3.87232 5.95866 3.83251 5.91912C3.79297 5.8793 3.79297 5.81512 3.79297 5.68783ZM3.79297 8.12533C3.79297 8.63612 3.79297 8.89124 3.95168 9.04995C4.11039 9.20866 4.36551 9.20866 4.8763 9.20866H8.1263C8.63709 9.20866 8.89222 9.20866 9.05093 9.04995C9.20964 8.89124 9.20964 8.63612 9.20964 8.12533V6.77116C9.20964 6.6436 9.20964 6.57968 9.17009 6.53987C9.13028 6.50033 9.06609 6.50033 8.9388 6.50033H4.0638C3.93624 6.50033 3.87232 6.50033 3.83251 6.53987C3.79297 6.57968 3.79297 6.64387 3.79297 6.77116V8.12533Z",
    fill: "#6796CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14666 3.49023C5.46281 3.49023 5.71911 3.74653 5.71911 4.06268V4.87518C5.71911 5.19133 5.46281 5.44762 5.14666 5.44762C4.83051 5.44762 4.57422 5.19133 4.57422 4.87518V4.06268C4.57422 3.74653 4.83051 3.49023 5.14666 3.49023ZM7.855 3.49023C8.17115 3.49023 8.42744 3.74653 8.42744 4.06268V4.87518C8.42744 5.19133 8.17115 5.44762 7.855 5.44762C7.53884 5.44762 7.28255 5.19133 7.28255 4.87518V4.06268C7.28255 3.74653 7.53884 3.49023 7.855 3.49023Z",
    fill: "#6796CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3683_4159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.5,
    height: 6.5,
    fill: "white",
    transform: "translate(3.25 3.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataC);
export default __webpack_public_path__ + "static/media/icon-data-c.dba5292cea489b3d44861e1891cd7150.svg";
export { ForwardRef as ReactComponent };